import moment from "moment"

export const fmtUSD = (n: number | null | undefined): string =>
	n == null
		? "—"
		: `$${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export const rateToPercent = (n: number): number =>
	parseFloat((n * 100).toFixed(2))

export const fmtRate = (n: number | null | undefined): string =>
	n == null ? "—" : `${rateToPercent(n)}%`

export const fmtDate = (d: string | null | undefined): string =>
	d == null ? "—" : moment(d).format("MM/DD/YYYY")
